<template>
  <transition>
    <LoadingWidget v-if="loading" />

    <section
      :class="[this.courseId ? '' : 'noticias']"
      v-else-if="items.length"
    >
      <v-container
        :class="[
          this.courseId
            ? 'overflow-hidden container-large'
            : 'pr-0 pr-md-3 py-15 mt-10 overflow-hidden container-large',
        ]"
      >
        <TitleWidget>{{ title }}</TitleWidget>

        <CarouselWidget
          class="mt-10"
          :items="items"
          v-bind="carouselSettings"
          :center="center"
          :gap="gap"
          dots
        >
          <template #item="{ item }">
            <ArticleCard v-bind="item" />
          </template>
        </CarouselWidget>

        <ButtonWidget
          v-if="totalItems > carouselSettings.itemsToShow[breakpointName]"
          class="mt-10 mt-md-13 mt-lg-16"
          align="center"
          :to="path"
        >
          Ver Mais
        </ButtonWidget>
      </v-container>
    </section>
  </transition>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ArticleCard from "../cards/ArticleCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "articles",
  path: "/noticias",
};

const _pagination = {
  itemsPerPage: 4,
  returnTotalItems: 1,
};

const _carouselSettings = {
  itemsToShow: {
    xs: 1.2,
    sm: 2.5,
    md: 4,
    lg: 4,
    xl: 4,
  },
};

const _data = {
  loading: true,
  title: "Notícias",
  path: _config.path,
  totalItems: 0,
  carouselSettings: _carouselSettings,
};

export default {
  props: {
    courseId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, subtitle, date }) => ({
          img,
          title,
          subtitle,
          date,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
    breakpointName() {
      return this.$vuetify.breakpoint.name;
    },
    gap() {
      switch (this.breakpointName) {
        case "xs":
        case "sm":
        case "md":
          return 12;
        default:
          return 30;
      }
    },
    center() {
      switch (this.breakpointName) {
        case "xs":
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        ..._pagination,
      };

      if (this.courseId) {
        params.courseId = this.courseId;
      }

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (params.returnTotalItems) {
              state.list = data.list;
              this.totalItems = data.totalItems;
            } else {
              state.list = data;
            }
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    LoadingWidget,
    TitleWidget,
    CarouselWidget,
    ArticleCard,
    ButtonWidget,
  },
};
</script>

<style>
.noticias {
  background: var(--v-grey-lighten5);
}
</style>
